module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-tit"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction. A Nationals Medley: People, Places and Things")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1"
    }
  }, [_c('b', [_vm._v("Part I. A Prelude")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/ch1"
    }
  }, [_vm._v("Chapter 1. Basket Ball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2. Syracuse Nationals, 1946–1949: The NBL Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part II. The Syracuse Nationals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3. The Franchise’s First Star, 1949–1954")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4. A Gut-Wrenching Championship, 1954–1955")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5. A Big-League Team in a Small Town, 1955–1959")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6. Nats Wilt after Chamberlain Arrives, 1959–1961")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7. The Sixties, 1961–1963")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8. A Cognitive Transition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part III. The Syracuse Legacy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9. The 24-Second Clock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10. The Calls from Springfield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11. Professional Basketball, Syracuse Style")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0